module.exports = __webpack_public_path__ + "vue-tags-input/assets/fonts/icomoon-57d17467e665f76c99f1a50cbc8a818a.ttf";